import * as THREE from 'three';
import Exp from '../Exp';

export default class Materials {
    constructor() {
        this.mtl_dark_skin = new THREE.MeshStandardMaterial({
            color: 0x020202,
            flatShading: true,
            roughness: .8,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
            skinning: true,
            //wireframe: true,
        })
        this.mtl_dark = new THREE.MeshStandardMaterial({
            color: 0x020202,
            flatShading: true,
            roughness: .8,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
            //wireframe: true
        })
        this.mtl_stand = new THREE.MeshStandardMaterial({
            color: 0x020202,
            flatShading: true,
            roughness: .8,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
            //wireframe: true
        })
        this.mtl_dark_hive = new THREE.MeshStandardMaterial({
            color: 0x020202,
            //flatShading: true,
            roughness: .8,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
        })
        this.mtl_dark_bee = new THREE.MeshStandardMaterial({
            color: 0x020202,
            flatShading: true,
            roughness: .8,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
            skinning: true,
        })
        this.mtl_sphere = new THREE.MeshStandardMaterial({
            color: 0x0e0e0e,
            //emissive: 0x0e0e0e,
            //wireframe: true,
        })
        this.mtl_points = new THREE.PointsMaterial({
            size: 0.0,
            sizeAttenuation: true,
        })
    }
}